module.exports = __webpack_public_path__ + "static/media/sample.09191721.png";